export const frontmatter = {
    "draft": true,
    "title": "Usuarios",
    "description": "Gestión de usuarios en OnnIA.",
    "sidebar_label": "Usuarios",
    "sidebar_group": "referencia",
    "sidebar_order": 1
}

export const toc = []